import { forwardRef } from 'react';
import classNames from 'classnames';
import Icon from 'components/Icon';

import './style.css';

const Button = (
	{
		title,
		onClick,
		type = 'primary',
		small,
		startIcon,
		endIcon,
		endIconIconSize,
		iconSize,
		disabled,
		skew,
		iconColor,
		rectangle,
		extraClassName,
	},
	ref
) => {
	const className = classNames('Button', {
		skew,
		small,
		startIcon,
		endIcon,
		[`Button__${type}`]: type,
		['rectangle']: rectangle,
		[extraClassName]: extraClassName,
	});

	return (
		<button className={className} onClick={onClick} disabled={disabled} ref={ref}>
			{startIcon && <Icon icon={startIcon} size={iconSize} disabled={disabled} color={iconColor} />}
			<span>{title}</span>
			{endIcon && <Icon icon={endIcon} size={endIconIconSize} disabled={disabled} color={iconColor} />}
		</button>
	);
};

export default forwardRef(Button);
